import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import confetti from 'canvas-confetti';

@Component({
  selector: 'app-certificat-valide',
  standalone: true,
  imports: [IonIcon],
  templateUrl: './certificat-valide.component.html',
  styleUrls: ['./certificat-valide.component.scss'],
})
export class CertificatValideComponent implements OnInit {
  @Output() done = new EventEmitter<void>();

  ngOnInit() {
    // Burst initial au centre
    setTimeout(() => {
      confetti({
        particleCount: 80,
        spread: 70,
        origin: { x: 0.5, y: 0.55 },
        colors: ['#1a7a3c', '#c9a84c', '#faf8f4', '#1a1208'],
        scalar: 0.9,
      });
    }, 500);

    // Deux canons depuis les côtés
    setTimeout(() => {
      confetti({ particleCount: 40, angle: 60,  spread: 55, origin: { x: 0, y: 0.65 }, colors: ['#1a7a3c', '#c9a84c'] });
      confetti({ particleCount: 40, angle: 120, spread: 55, origin: { x: 1, y: 0.65 }, colors: ['#1a7a3c', '#c9a84c'] });
    }, 900);

    setTimeout(() => this.done.emit(), 3200);
  }
}
